import { registerPlugin } from '@capacitor/core';
const MosipSbiCapacitorPlugin = registerPlugin('MosipSbiCapacitorPlugin', {});
export * from './definitions';
export { MosipSbiCapacitorPlugin };
//# sourceMappingURL=index.js.map